import { render, staticRenderFns } from "./QuestionMetricComment.vue?vue&type=template&id=c67cf72a&scoped=true&"
import script from "./QuestionMetricComment.vue?vue&type=script&lang=js&"
export * from "./QuestionMetricComment.vue?vue&type=script&lang=js&"
import style0 from "./QuestionMetricComment.vue?vue&type=style&index=0&id=c67cf72a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67cf72a",
  null
  
)

export default component.exports